import React, { useState, useEffect } from "react";
import { Button, OutlinedInput, Pagination, Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import axios from "axios";
import { BaseUrl } from "../../container/BaseUrl/BaseUrl";
import moment from "moment";
import { RiErrorWarningLine } from "react-icons/ri";
import { ArrowCounterClockwise } from "@phosphor-icons/react";

const QueueChat = () => {
  const [queueList, setqueueList] = useState([]);
  const [agentlist, setAgentlist] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [selectedAgents, setSelectedAgents] = useState({});

  const [spinner, setspinner] = useState("");

  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    QueueChatAPi();
  }, [page]);

  const QueueChatAPi = () => {
    axios
      .post(
        BaseUrl + "/users/listqueuedsession",
        {
          limit: 10,
          offset: page == 1 ? 0 : (page - 1) * 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setqueueList(res.data.data);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner("");
          }, 1500);
        } else {
          setqueueList([]);
          setPagination(0);
          setTimeout(() => {
            setspinner("");
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner("");
        }, 1500);
      });
  };

  const agentListdropdown = async () => {
    const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/listagentList",
        {
          user_id: basedOnRole.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setAgentlist(res.data.data);
      })
      .catch((err) => {
        setShow(true);
      });
  };

  const updateAgent = async (value, value2) => {
    await axios
      .post(
        BaseUrl + "/users/updateAgent",
        {
          chat_session_id: value,
          agentId: value2,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        QueueChatAPi();
      })
      .catch((err) => {
        setShow(true);
      });
  };

  useEffect(() => {
    agentListdropdown();
  }, []);

  return (
    <>
      <div className="sessiontable" style={{ overflow: "hidden" }}>
        <header className="header_role ">
          <div className="conatiner-fluid">
            <nav
              className="navbar "
              style={{ paddingTop: "0px", paddingBottom: "0px" }}
            >
              <div className="container-fluid p-0">
                <div className="hed_left d-flex">
                  <Typography>Queued Interaction</Typography>
                </div>
                <div className="hed_right d-flex ">
                  <Button
                    size="small"
                    variant="contained"
                    endIcon={
                      <ArrowCounterClockwise
                        weight="bold"
                        size={18}
                        style={{ animation: spinner }}
                      />
                    }
                    onClick={() => {
                      agentListdropdown();
                      QueueChatAPi();
                      setspinner("rotate 1s infinite");
                    }}
                  >
                    Refresh
                  </Button>
                </div>
              </div>
            </nav>
          </div>
        </header>
        <div className="container-fluid" style={{ paddingLeft: "1px" }}>
          <div className="container-fluid p-2">
            <div className="card fixed-table-card vh-79 ">
              <div className="card-body agentContactbody">
                <div className="table-responsive vhm-68">
                  <table className="table table-sm  table-hover align-middle table-fixeded">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Phone Number</th>
                        <th scope="col">Email</th>
                        <th scope="col">Channel</th>
                        <th scope="col">Skillset</th>
                        <th scope="col">Arrival At</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {queueList.length > 0 ? (
                        queueList.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td>{item.unique_id.username}</td>
                              <td>{item.phonenumber}</td>
                              <td>{item.email}</td>
                              <td>{item.channel}</td>
                              <td>{item.skillset}</td>
                              <td>
                                {moment(item.createdAt).format("L hh:mm:ss A")}
                              </td>
                              <td>
                                <FormControl sx={{ width: 140 }} size="small">
                                  <InputLabel
                                    id={`select-agent-label-${item.chat_session_id}`}
                                  >
                                    Select Agent
                                  </InputLabel>

                                  <Select
                                    labelId={`select-agent-label-${item.chat_session_id}`}
                                    id={`select-agent-${item.chat_session_id}`}
                                    value={
                                      selectedAgents[item.chat_session_id] || ""
                                    }
                                    onChange={(event) => {
                                      const { value } = event.target;
                                      setSelectedAgents((prevState) => ({
                                        ...prevState,
                                        [item.chat_session_id]: value,
                                      }));
                                      updateAgent(item.chat_session_id, value);
                                    }}
                                    input={
                                      <OutlinedInput label="Select Agent" />
                                    }
                                    MenuProps={{
                                      style: {
                                        top: "0px",
                                        maxHeight: "350px",
                                      },
                                    }}
                                  >
                                    {agentlist.length > 0 ? (
                                      agentlist.map((agent) => (
                                        <MenuItem
                                          value={agent.user_id}
                                          key={agent.user_id}
                                        >
                                          {agent.username}
                                        </MenuItem>
                                      ))
                                    ) : (
                                      <MenuItem>{"No Data"}</MenuItem>
                                    )}
                                  </Select>
                                </FormControl>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <div
                          className="text-muted"
                          style={{
                            flexDirection: "column",
                            marginTop: "20%",
                            display: "flex",
                            position: "absolute",
                            left: "45%",
                            bottom: "40%",
                          }}
                        >
                          <span className="mx-auto">
                            <RiErrorWarningLine size={30} />
                          </span>
                          <span className="mx-auto">
                            <h5
                              className="text-muted mt-2"
                              style={{ fontFamily: "poppins" }}
                            >
                              No Data Found
                            </h5>
                          </span>
                        </div>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-footer rounded-0 d-flex justify-content-between">
                <div>
                  Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                  {Math.min(page * 10, pagination)} of {pagination} entries
                </div>
                <Pagination
                  count={Math.ceil(pagination / 10)}
                  page={page}
                  color="primary"
                  size="small"
                  style={{ float: "right" }}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QueueChat;
